import React from 'react';
import { Card, Table, Descriptions, Tag, Space, Typography, Empty } from 'antd';
import { DollarOutlined, CalendarOutlined } from '@ant-design/icons';

const { Text } = Typography;

/**
 * 汇率快照展示组件
 * 以表格形式展示批次使用的汇率快照
 */
const ExchangeRateDisplay = ({ exchangeRatesSnapshot }) => {
    if (!exchangeRatesSnapshot) {
        return <Empty description="无汇率快照数据" />;
    }

    const { base_currency, snapshot_date, rates = {} } = exchangeRatesSnapshot;

    // 转换汇率数据为表格数据源
    const dataSource = Object.entries(rates).map(([currency, rate], index) => ({
        key: index,
        from_currency: currency,
        to_currency: base_currency,
        rate: rate,
    }));

    // 表格列定义
    const columns = [
        {
            title: '序号',
            key: 'index',
            width: 80,
            align: 'center',
            render: (_, __, index) => index + 1
        },
        {
            title: '源货币',
            dataIndex: 'from_currency',
            key: 'from_currency',
            width: 120,
            render: (currency) => (
                <Tag color="blue" style={{ fontSize: 14 }}>
                    {currency}
                </Tag>
            )
        },
        {
            title: '转换方向',
            key: 'direction',
            width: 100,
            align: 'center',
            render: () => <Text strong>→</Text>
        },
        {
            title: '目标货币',
            dataIndex: 'to_currency',
            key: 'to_currency',
            width: 120,
            render: (currency) => (
                <Tag color="green" style={{ fontSize: 14 }}>
                    {currency}
                </Tag>
            )
        },
        {
            title: '汇率',
            dataIndex: 'rate',
            key: 'rate',
            width: 150,
            align: 'right',
            render: (rate) => (
                <Text strong style={{ fontSize: 14, color: '#1890ff' }}>
                    {Number(rate).toFixed(6)}
                </Text>
            )
        },
        {
            title: '示例换算',
            key: 'example',
            render: (_, record) => (
                <Text type="secondary">
                    1 {record.from_currency} = {Number(record.rate).toFixed(4)} {record.to_currency}
                </Text>
            )
        }
    ];

    return (
        <div>
            {/* 快照基本信息 */}
            <Card size="small" style={{ marginBottom: 16 }}>
                <Descriptions column={3} size="small">
                    <Descriptions.Item 
                        label={
                            <Space>
                                <DollarOutlined />
                                <span>基准货币</span>
                            </Space>
                        }
                    >
                        <Tag color="green" style={{ fontSize: 16, padding: '4px 12px' }}>
                            {base_currency}
                        </Tag>
                    </Descriptions.Item>
                    <Descriptions.Item 
                        label={
                            <Space>
                                <CalendarOutlined />
                                <span>快照日期</span>
                            </Space>
                        }
                    >
                        <Text strong>{snapshot_date}</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="货币数量">
                        <Text strong>{Object.keys(rates).length} 种</Text>
                    </Descriptions.Item>
                </Descriptions>
            </Card>

            {/* 汇率表格 */}
            <Card title="汇率明细" size="small">
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    size="small"
                    bordered
                />
            </Card>

            {/* 说明信息 */}
            <Card size="small" style={{ marginTop: 16, backgroundColor: '#f0f5ff' }}>
                <Space direction="vertical" size="small">
                    <Text strong style={{ color: '#1890ff' }}>💡 说明</Text>
                    <Text type="secondary">
                        • 本批次核算使用上述汇率快照将所有成本统一转换为 {base_currency}
                    </Text>
                    <Text type="secondary">
                        • 汇率快照时间为批次开始日期，确保核算的一致性
                    </Text>
                    <Text type="secondary">
                        • 所有成本项按其原始货币乘以对应汇率后汇总
                    </Text>
                </Space>
            </Card>
        </div>
    );
};

export default ExchangeRateDisplay;

